export default __webpack_public_path__ + "ab39b1fad268c4b40c45bffffd3aa9bc.woff2?proxy=wpt-abc";